import {
  createApiRef,
  BackstageIdentityApi,
  SessionApi,
  ProfileInfoApi,
  OpenIdConnectApi,
} from '@backstage/frontend-plugin-api';

export const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.keycloak.oidc',
});
